angular.module('env.data.models.addressModel', [])

    .config(function (restProvider, RepresentationModelFieldTypes) {
        restProvider.defineModel("AddressModel",
            {
                extend: ['BaseModel'],
                url: "addresses",
                fields: {
                    line1: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    line2: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    city: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    companyName: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    contactLastName: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    contactFirstName: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    contactTitle: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    country: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    email: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    postalCode: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    region: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    telephone: {
                        type: RepresentationModelFieldTypes.STRING
                    }
                },
                methods: {
                    toFormattedString: function (rest, model) {
                        var addressParts = _.filter([
                                //Get address line1 if not empty, remove 'carriage return' symbols, filter out duplicate words (often users copy-past duplicate words)
                                (model.$model.line1 || '').replace('\n', ' ').split(' ').filter(function (word, i, allWords) { return i === allWords.indexOf(word); }).join(' '),
                                //Get address line 2 if not empty, remove 'carriage return' symbols, filter out duplicate words (often users copy-past duplicate words)
                                model.$model.line2 !== model.$model.line1 ?
                                (model.$model.line2 || '').replace('\n', ' ').split(' ').filter(function (word, i, allWords) { return i === allWords.indexOf(word); }).join(' ') : '',
                                model.$model.city,
                                model.$model.postalCode,
                                model.$model.country
                            ],
                            function(a) {
                                return !angular.isUndefined(a) && a !== null && a.length > 0;
                            });
                        
                        return addressParts.join(', ');
                    }
                }
            }
        );
    })

;
